'use client';

import { Suspense, type ReactElement } from 'react';
import { Await } from 'react-router';
import type { SupplyChainContent } from '@/lib/api/fetch-supply-chain';
import SupplyChain, { type SupplyChainProps } from '@/components/supply-chain';
import { SupplyChainSkeleton } from '@/components/supply-chain/supply-chain-skeleton';

type DeferredProps = {
    contentPromise: Promise<SupplyChainContent | null>;
} & Omit<SupplyChainProps, 'data'>;

/** Resolves deferred SupplyChain custom-object data from the category loader behind Suspense. */
export function SupplyChainDeferred({ contentPromise, className, ...supplyChainProps }: DeferredProps): ReactElement {
    return (
        <Suspense fallback={<SupplyChainSkeleton className={className} />}>
            <Await resolve={contentPromise}>
                {(data) => <SupplyChain data={data} className={className} {...supplyChainProps} />}
            </Await>
        </Suspense>
    );
}
